<template>
  <div>
    <b-modal
      size="lg"
      v-model="visible"
    >
    <template slot="modal-title">
      {{titulo}}
    </template>

      <div>
        <b-row>
          <b-col lg="12">
            <b-form>
              <b-card-body>
                <b-row>

                  <b-col sm="6">
                    <b-form-group
                      :label="crearLabel('Actividad', 'graactivi', 'datosFormulario')"
                      label-for="graactivi">
                      <b-form-select 
                        :options="valActividad"
                        v-model="datosFormulario.graactivi"
                        :disabled="campoBloqueado('graactivi', 'datosFormulario')"
                        
                      >
                      </b-form-select>
                     
                      <span class="error-validacion-campo">
                        {{ mensajeValidacionCampo.graactivi }}
                      </span>
                    </b-form-group>

                    <b-form-group
                      :label="crearLabel('Actividad Requerida', 'grarequis', 'datosFormulario')"
                      label-for="grarequis">
                      <b-form-select 
                        :options="valActividadRequerida"
                        v-model="datosFormulario.grarequis"
                        :disabled="campoBloqueado('grarequis', 'datosFormulario')"
                        
                      >
                      </b-form-select>
                     
                      <span class="error-validacion-campo">
                        {{ mensajeValidacionCampo.grarequis }}
                      </span>
                    </b-form-group>
                    
                  </b-col>
                  
                </b-row>
              </b-card-body>
            </b-form>
          </b-col>
        </b-row>
      </div>
      <div
        slot="modal-footer"
        class="w-100"
      >
        <p class="float-left"></p>
        <b-button
          type="submit"
          variant="secondary"
          class="float-right"
          @click="modalEditarDependencia = false; visible = false;"
        ><i class="fa fa-close"></i> Cerrar</b-button>
        <b-button
          type="submit"
          variant="primary"
          class="float-right"
          style="margin-right:8px;"
          @click="guardarDependencia"
        ><i class="fa fa-save"></i> Guardar</b-button>
      </div>
    </b-modal>
  
  </div>
</template>
<script>

import axios from "axios";
import apiActividades from "@/components/services/apiActividades";
import { globalesMixin } from "../../components/mixins/globalesMixin";

export default {
  name: "EditarEstado",
  mixins: [globalesMixin],
  data: function() {
    return {
      titulo: "",
      visible: false,
      modalEditarEstado: false,
      modalAgregarEstado: false,
      datosFormulario: {
        graproced: "",
        graactivi: "",
        desc_actividad: "",
        grarequis: "",
        desc_requis: "",
        grasecuencia: "",
        graactivo: "",
        desc_activo: "",
        grausumodif: "",
        grafmodif: "",
        gracodigo: ""
      },

      valActividad: [],
      valActividadRequerida: [],

      datosFormularioEstado: [],
      mensajeValidacionCampo: {}
    };
  },
  methods: {
    obtenerDependencia(mail, usuario, p_gsaproced, gracodigo, tiporec) {
      this.titulo = "Editar Dependencia";
      this.mensajeValidacionCampo = {};
      return apiActividades
        .buscarDependencia(mail, usuario, p_gsaproced, gracodigo, tiporec)
        .then(response => {
          
          this.datosFormulario.graproced = p_gsaproced;
          this.datosFormulario.graactivi = "",
          this.datosFormulario.desc_actividad = "",
          this.datosFormulario.grarequis = "",
          this.datosFormulario.desc_requis = "",
          this.datosFormulario.grasecuencia = "",
          this.datosFormulario.graactivo = "",
          this.datosFormulario.desc_activo = "",
          this.datosFormulario.grausumodif = "",
          this.datosFormulario.grafmodif = "",
          this.datosFormulario.gracodigo = ""
          
          response.data = this.keysMinuscula(response.data);
          this.datosFormulario = response.data.res[0];

          this.datosFormularioEstado = response.data.festado;

          //Carga lista de tipo actividades
          var tiposActividades = new Array();
          var lista_tipos_actividades = response.data.actividades;
          for(var i = 0; i < lista_tipos_actividades.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_actividades[i]["gsanombre"];
              obj.text = lista_tipos_actividades[i]["gsadescripcion"];
              tiposActividades.push(obj);
          }
          this.valActividad = tiposActividades;
          this.valActividadRequerida = tiposActividades;

          this.modalEditarDependencia = true;
          this.visible = true;
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    pre_insertarDependencia(mail, usuario, p_gsaproced, gracodigo) {
      this.titulo = "Agregar Dependencia";
      this.mensajeValidacionCampo = {};
      return apiActividades
        .pre_insertarDependencia(mail, usuario, p_gsaproced, gracodigo)
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          this.datosFormulario.graproced = p_gsaproced;
          this.datosFormulario.graactivi = "",
          this.datosFormulario.desc_actividad = "",
          this.datosFormulario.grarequis = "",
          this.datosFormulario.desc_requis = "",
          this.datosFormulario.grasecuencia = "",
          this.datosFormulario.graactivo = "",
          this.datosFormulario.desc_activo = "",
          this.datosFormulario.grausumodif = "",
          this.datosFormulario.grafmodif = "",
          this.datosFormulario.gracodigo = ""
      
          this.datosFormularioEstado = response.data.festado;

          //Carga lista de tipo actividades
          var tiposActividades = new Array();
          var lista_tipos_actividades = response.data.actividades;
          for(var i = 0; i < lista_tipos_actividades.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_actividades[i]["gsanombre"];
              obj.text = lista_tipos_actividades[i]["gsadescripcion"];
              tiposActividades.push(obj);
          }
          this.valActividad = tiposActividades;
          this.valActividadRequerida = tiposActividades;
         
          this.modalAgregarDependencia = true;
          this.visible = true;

        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    guardarDependencia(event) {
      event.preventDefault();
      this.$Progress.start();
      
      
      if (this.modalEditarDependencia){
        return apiActividades
        .modificarDependencia(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "datosFormulario"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.$emit("actualizaDependencias");
            this.modalEditarDependencia = false;
            this.visible = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
      }else if (this.modalAgregarDependencia) {
        return apiActividades
        .insertarDependencia(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "datosFormulario"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.$emit("actualizaDependencias");
            this.modalAgregarDependencia = false;
            this.visible = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
      }

    }
    
  }
};
</script>
<style scoped>
</style>
